import { ApolloClient } from '@apollo/client';
import {
  AutocompleteContext,
  AutocompleteRawContext,
  autocompleteParts as autocompleteContextParts,
} from '@jupiterone/query-language-autocomplete';
import { J1ApolloClient } from '@jupiterone/jupiter-web-toolkit';
import flow from 'lodash/flow';
import autocompleteApi from '../autocompleteApi';

const contextFromRaw = (
  context: AutocompleteRawContext,
  _client?: ApolloClient<any>
): AutocompleteContext => {
  const client = _client || J1ApolloClient.sharedOptional();
  if (!client) {
    throw new Error('Apollo client is required.');
  }

  return {
    ...context,
    properties: async (entity: string) => {
      return autocompleteApi
        .properties(client, entity)
        .then(
          flow(autocompleteContextParts.toProperties, (p) => p[entity] || [])
        );
    },
    relationships: async (sourceEntity: string) => {
      return autocompleteApi
        .relationships(client, sourceEntity)
        .then(
          flow(
            autocompleteContextParts.toRelationships,
            (r) => r[sourceEntity] || []
          )
        );
    },
  };
};

export default contextFromRaw;
